// @ts-ignore
import sha1 from 'sha-1';
import { postRequest } from './util/requestAlias';
import { buildURL, buildRequestBody } from './util/requestHandler';
import defaults from './defaults';
/**
 * 生成 Token
 *
 * 通过账号密码登陆，返回 Token 信息。  若登录失败，且返回信息中含参数 &#x60;captcha_token&#x60; 和 &#x60;captcha_image&#x60;， 表示下次调用该接口时，需要用户输入图形验证码，并把 &#x60;captcha_token&#x60; 和 &#x60;captcha_code&#x60; 参数传递到服务端。
 */

export const login = params => {
  if (params.password) {
    params.password = sha1(params.password);
  }

  return postRequest(buildURL('/tokens', params), buildRequestBody(params, ['name', 'password', 'device', 'captcha_token', 'captcha_code'])).then(response => {
    if (!response.code) {
      defaults.adapter.setStorage('token', response.data.token);
    }

    return response;
  });
};